/* @flow */
import React from 'react';
import { scaleTime } from 'd3-scale';
import classnames from 'classnames/bind';

import s from './DateRangeSlider.styl';
const cx = classnames.bind(s);

type DateRangeSliderProps = {
  extent: [number, number],
  width: number,
  className?: string,
};

export class DateRangeSlider extends React.Component {
  props: DateRangeSliderProps;
  scale: D3$TimeScale;

  state = {
    selection: this.props.extent,
    sliderWidth: this.props.width,
  };

  /**
   * Set up the scale to map between the passed extent (timestamps) and the
   * width of the component.
   */
  constructor(props: DateRangeSliderProps) {
    super(props);

    const scale = scaleTime()
      .domain(props.extent)
      .range([0, props.width])
      .nice();

    this.scale = scale;
  }

  render() {
    return (
      <div style={{ width: this.props.width }} className={this.props.className}>
        <div style={{ width: this.state.sliderWidth }} className={cx('slider')}>
          <span className={cx('handle', 'w')} />
          <span className={cx('handle', 'e')} />
        </div>
        <div className={cx('tooltips')}>
          {/* Put the two date end range tooltips in here */}
        </div>
      </div>
    );
  }
}



// WEBPACK FOOTER //
// ./web_modules/trustar/components/DateRangeSlider.js